import { HelpButtonProps } from './HelpButton.interface';
import { TertiaryButton } from '@axafr-btc-ds/buttons';
import { IconPhoneEnabled } from '@axafr-btc-ds/icons';
import React, { MouseEvent, useState } from 'react';
import { HelpModal } from 'components';
import styles from './HelpButton.module.css';

export function HelpButton({
    isDisabled,
    phoneNumber,
}: HelpButtonProps): JSX.Element {
    const [ isModalOpen, setIsModalOpen ] = useState<boolean>(false);

    const handleSeeMoreClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        setIsModalOpen(true);
    };

    const handleModalClose = (
        event:
            | MouseEvent<HTMLButtonElement | HTMLDivElement>
            | React.KeyboardEvent<HTMLButtonElement>
    ) => {
        event.stopPropagation();
        setIsModalOpen(false);
    };

    return (
        <div className={ styles.host }>
            <TertiaryButton align="right" onClick={ handleSeeMoreClick } icon={ IconPhoneEnabled } isCircle>
                Besoin d'aide
            </TertiaryButton>

            { isModalOpen && (
                <HelpModal
                    isOpen={ isModalOpen }
                    onClose={ handleModalClose }
                    title="Besoin d'aide pour votre devis ?"
                    phoneNumber={ phoneNumber }
                />
            ) }
        </div>
    );
}
